import { cardKey, cardTimesRequest } from "./card-requests";
import { apiQuery, type SpecialistsSearch } from "./search-params";
import { sdk } from "@/api/sdk";
import { reportApiOutage } from "@/lib/api-outage";

/** Cards whose open times are read with the page: about a screen's worth. */
const TIMES_WITH_PAGE = 6;

export const directoryCitiesRequest = () => sdk.directory.cities.$get;

/**
 * The first page of a search, read before the page draws, so it arrives filled and search engines
 * read real results. A search that cannot be reached shows the empty page, not an error.
 */
export const loadSearchPage = async (search: SpecialistsSearch) => {
  const result = await sdk.directory.search.$get.setQueryParams(apiQuery(search)).send();
  if (!result.data) reportApiOutage();
  // The first cards' times come with the page, so what is on screen is complete at once.
  const firstCards = result.data?.cards.slice(0, TIMES_WITH_PAGE) ?? [];
  const times = await Promise.all(firstCards.map((card) => cardTimesRequest(card).send()));
  const firstTimes = Object.fromEntries(
    firstCards.map((card, index) => [cardKey(card), times[index]?.data?.specialists[0] ?? null]),
  );
  return { result: result.data, firstTimes };
};
